import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g id="icon/system/arrow filled">
    <path
      id="Combined Shape"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9999 2.53369C7.55992 2.53369 2.33325 7.76036 2.33325 14.2004C2.33325 20.6404 7.55992 25.867 13.9999 25.867C20.4399 25.867 25.6666 20.6404 25.6666 14.2004C25.6666 7.76036 20.4399 2.53369 13.9999 2.53369ZM18.3104 15.0664L12.5764 20.8414C12.1014 21.3198 11.3313 21.3198 10.8563 20.8414C10.3812 20.363 10.3812 19.5873 10.8563 19.1089L15.7301 14.2002L10.8563 9.29149C10.3812 8.81308 10.3812 8.03742 10.8563 7.559C11.3313 7.08059 12.1014 7.08059 12.5764 7.559L18.3104 13.334C18.7854 13.8124 18.7854 14.588 18.3104 15.0664Z"
      fill={fill}
    />
  </g>
);

export default Icon;
